export default __webpack_public_path__ + "static/Screen Shot 2021-12-03 at 20.13.15-c4aba7d5a8081e2a59c872dbbdb33f89.png";